/**
 * Valores enviados em JSON como `motivo` ao desvincular condutor (string estável para a API).
 */
export enum B2bDesvincularCondutorMotivo {
  Substituicao = 'Substituicao',
  SolicitacaoCliente = 'SolicitacaoCliente',
  DadosCondutorIncorretos = 'DadosCondutorIncorretos',
  CondutorIndisponivel = 'CondutorIndisponivel',
  FimLocacaoOuDevolucao = 'FimLocacaoOuDevolucao',
  Outro = 'Outro'
}

export const B2B_DESVINCULAR_CONDUTOR_MOTIVO_OPTIONS: { value: B2bDesvincularCondutorMotivo; label: string }[] = [
  { value: B2bDesvincularCondutorMotivo.Substituicao, label: 'Substituição de condutor' },
  { value: B2bDesvincularCondutorMotivo.SolicitacaoCliente, label: 'Solicitação do cliente' },
  { value: B2bDesvincularCondutorMotivo.DadosCondutorIncorretos, label: 'Dados do condutor incorretos' },
  { value: B2bDesvincularCondutorMotivo.CondutorIndisponivel, label: 'Condutor indisponível' },
  { value: B2bDesvincularCondutorMotivo.FimLocacaoOuDevolucao, label: 'Fim da locação / devolução do veículo' },
  { value: B2bDesvincularCondutorMotivo.Outro, label: 'Outro' }
];

/** Mínimo de caracteres no texto livre quando o motivo é Outro. */
export const B2B_DESVINCULAR_OUTRO_MIN_LENGTH = 5;

/**
 * Monta o `motivo` enviado à API.
 * Para Outro, exige detalhe e retorna `Outro — {texto}`.
 */
export function resolveDesvincularMotivoPayload(
  code: string | null | undefined,
  detalhe?: string | null
): { ok: true; motivo: string } | { ok: false; error: string } {
  const selected = String(code ?? '').trim();
  if (!selected) {
    return { ok: false, error: 'Selecione o motivo da desvinculação.' };
  }

  if (selected !== B2bDesvincularCondutorMotivo.Outro) {
    return { ok: true, motivo: selected };
  }

  const text = String(detalhe ?? '').trim();
  if (text.length < B2B_DESVINCULAR_OUTRO_MIN_LENGTH) {
    return {
      ok: false,
      error: `Descreva o motivo (mínimo ${B2B_DESVINCULAR_OUTRO_MIN_LENGTH} caracteres).`
    };
  }

  return { ok: true, motivo: `Outro — ${text}` };
}
